import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import { featureQueryOptions } from '@/queries/useFeaturesQuery';
import type { RouteSignFeature } from '@/types/RouteSignFeature';

export const routeSignQueryOptions = ({ routeSignLocationId }: { routeSignLocationId: string }) =>
  featureQueryOptions<RouteSignFeature>({
    collection: 'route_sign_view',
    query: { filter: `locationId = '${routeSignLocationId}'` },
  });

export const useRouteSignQuery = () => {
  const routeSignLocationId = useParams({
    strict: false,
    select: (params) => {
      if (!params.routeSignLocationId) {
        throw new Error('No `routeSignLocationId` in path');
      }

      return params.routeSignLocationId;
    },
  });

  return useQuery({
    ...routeSignQueryOptions({ routeSignLocationId }),
    placeholderData: keepPreviousData,
  });
};
